export enum QuestionnaireInputType {
  Radio = 'radio',
  Checkbox = 'checkbox',
}

export type QuestionOption = {
  value: string;
  description?: string;
  imageFile?: string;
  showConnectorSearch?: boolean;
};

type QuestionInputDataType = {
  inputType: QuestionnaireInputType;
  inputAnswers: {
    options: QuestionOption[];
    otherOptions?: QuestionOption[];
  };
};

type QuestionOffRampType = {
  answer: string;
  offRampId: string;
};

type FollowUpQuestion = QuestionType & {
  answer: string;
};

export type QuestionType = {
  id: string;
  questionTitle: string;
  optionsHeader?: string;
  otherOptionsHeader?: string;
  subText?: string;
  subTextTooltipUrl?: string;
  otherSubtext?: string;
  inputData: QuestionInputDataType;
  offRamps?: Array<QuestionOffRampType>;
  followUpQuestions?: Array<FollowUpQuestion>;
  allowSkip?: boolean;
  nextAlwaysEnabled?: boolean;
  showFreeTrialLink?: boolean;
};

export type OffRampType = {
  id: string;
  inputType: string;
  content: {
    heading: string;
    body: string;
    imageFile?: string | null;
    actionButtonText: string;
    actionButtonUrl: string;
    callToAction?: string;
  };
};

export type QuestionnaireResults = {
  questionnaireName: PrequalQuestionnaire['name'];
  selectedAnswers: Record<string, Array<string> | undefined>;
  offRampId: OffRampType['id'] | undefined;
};

export enum QuestionnaireEligibility {
  All = 'all',
  New = 'new',
  Existing = 'existing',
}

export type PrequalQuestionnaire = {
  name: string;
  flow: string;
  eligibility: QuestionnaireEligibility;
  campaignId: string;
  startPage: {
    id: string;
    content: {
      heading: string;
      body: string;
      subText?: string | null;
      imageFile: string | null;
      actionButtonText: string;
      actionButtonUrl: string | null;
      actionLink1Text?: string | null;
      actionLink1Url?: string | null;
    };
  };
  questions: Array<QuestionType>;
  offRamps?: Array<OffRampType>;
  endPage: {
    id: string;
    content: {
      heading: string;
      body: string;
      subHeading?: string;
      subText: string;
      imageFile: string | null;
      actionButtonText: string;
      actionButtonUrl: string;
      actionLink1Text?: string;
      actionLink1Url?: string;
      actionLink2Text?: string;
      actionLink2SubText?: string;
      actionLink2Url?: string;
    };
  };
};

export type StartProcessResponse = {
  businessKey: string;
  caseInstanceId: string | null;
  definitionId: string;
  ended: boolean;
  id: string;
  links: Array<Record<string, undefined>>;
  suspended: boolean;
  tenantId: string;
};

type CamundaTask = {
  assignee: string | null;
  camundaFormRef: string | null;
  caseDefinitionId: string | null;
  caseExecutionId: string | null;
  caseInstanceId: string | null;
  created: string;
  delegationState: string | null;
  description: string | null;
  due: string | null;
  executionId: string;
  followUp: string | null;
  formKey: string | null;
  id: string;
  lastUpdated: string | null;
  name: string;
  owner: string | null;
  parentTaskId: string | null;
  priority: number;
  processDefinitionId: string;
  processInstanceId: string;
  suspended: boolean;
  taskDefinitionKey: string;
  tenantId: string;
};

export type GetTaskResponse = Array<CamundaTask>;
